import { render, staticRenderFns } from "./BASchoolDetailPage.vue?vue&type=template&id=212608c8&"
import script from "./BASchoolDetailPage.vue?vue&type=script&lang=ts&"
export * from "./BASchoolDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./BASchoolDetailPage.vue?vue&type=style&index=0&id=212608c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports